import { CarouselThumb } from 'components/CarouselThumb';
import React, { useRef } from 'react';
import { cx } from '@linaria/core';
import { carouselWrapper } from 'components/Carousel/Carousel.styles';

interface CarouselProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  inputs: CF.API.Inputs.Input[];
  selected: string;
  altPrefix?: string;
  onSelect: (index: number) => void;
}

export const Carousel: React.FC<CarouselProps> = ({ inputs, selected, altPrefix = '', onSelect, className, ...rest }) => {
  const parentRef = useRef(null);
  return (
    <div role="menu" ref={parentRef} className={cx(carouselWrapper, className)} {...rest}>
      {inputs.map((input, idx) => (
        <CarouselThumb
          data-testid={`input-${idx}`}
          index={idx}
          key={input.id}
          altPrefix={altPrefix}
          input={input}
          isSelected={selected === input.id}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};
